export default "__VITE_ASSET__0a16ca8c__"